import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#2C73EB",
      light: "#10BADF",
      dark: "#145486",
    },
    secondary: {
      main: "#6F1486",
      light: "#9640AC",
    },
    background: {
      paper: "#EDF8FF",
    },
    tables:{
      head:'#2E86C1'
    }
  },
  typography: {
    fontFamily: ["Lato"],
    h4: {
      color: "#000",
      fontSize: 30,
    },
  },
});
